import http from "@/settings/apiSettings"
import axios from "axios";
import AppSettings from "@/settings/appSettings";

class CompanyDataService {
    getAll(): Promise<any> {
      return http.client.get("/auth/GetCompanies");
    }

    // login(data: any): Promise<any> {
    //   return http.client.post("/auth/login", data);
    // }

    //nu se actualizeaza header-ul, si decat sa refactorizez toata aplicatia
    //aiaie, mai facem si o MANEVRA d-asta evaziva
    //GHINION
    
    getMenus(): Promise<any> {
        return http.clientAuth.get("/auth/GetDrepturiMeniuri");
    }

    login(payload: { username?: string; password?: string; companyID?: string }) {
        return http.clientAuth.post("/auth/login", payload);
    }

    switchCompany(payload: { companyID: string }) {
      return http.clientAuth.post('/auth/switch-company', payload);
    }

    getAccessibleCompanies() {
      return http.clientAuth.get('/auth/companies');
    }
}

export default new CompanyDataService();